export default "__VITE_ASSET__5FAj8jsw__"